import { useEffect, useState } from 'react'

const getNavigatorOnLine = () =>
  typeof navigator === 'undefined' ? true : navigator.onLine

/**
 * Erkennung des Online/Offline-Status
 *
 * Dieser Hook stellt den Online/Offline-Status des Browsers bereit.
 *
 * **Achtung**: Diese Methode kann zu falsch-positiven Ergebnissen führen.
 * Sie meldet möglicherweise 'online', auch wenn keine vollständige
 * Internetverbindung besteht, z.B. bei eingeschränkter Konnektivität.
 *
 * @returns {boolean} True wenn online, false wenn offline
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/onLine
 */
export default function useOnlineDetection() {
  const [status, setStatus] = useState(getNavigatorOnLine())

  const updateStatus = () => setStatus(getNavigatorOnLine())

  useEffect(() => {
    // Initialzustand einmalig prüfen und merken
    updateStatus()

    // Events
    globalThis.addEventListener('online', updateStatus)
    globalThis.addEventListener('offline', updateStatus)

    return () => {
      globalThis.removeEventListener('online', updateStatus)
      globalThis.removeEventListener('offline', updateStatus)
    }
  }, [])

  return status
}
